// Determine environment from API URL or fall back to process.env.REACT_APP_ENV
const determineEnvironment = () => {
  const devApiDomain = process.env.REACT_APP_DEV_API_DOMAIN || '';
  if (process.env.REACT_APP_API_URL && devApiDomain && process.env.REACT_APP_API_URL.includes(devApiDomain)) {
    return 'development';
  }
  return process.env.REACT_APP_ENV;
};

// Helper function to get environment-specific variable
const getEnvVar = (baseKey) => {
  const envSuffix = ENV === 'development' ? '_DEVELOPMENT' : 
                    ENV === 'staging' ? '_STAGING' : 
                    ENV === 'preproduction' ? '_PREPRODUCTION' : 
                    '_PRODUCTION';
  return process.env[`REACT_APP_${baseKey}${envSuffix}`];
};

// Export environment variables
export const ENV = determineEnvironment();
export const API_URL = process.env.REACT_APP_API_URL;
export const SOURCE_URL = process.env.REACT_APP_SOURCE_URL;
export const Article_API_TOKEN = process.env.REACT_APP_ARTICLE_API_TOKEN;
export const GetStarted_API_TOKEN = process.env.REACT_APP_GET_STARTED_API_TOKEN;
export const Minisite_API_TOKEN = process.env.REACT_APP_MINISITE_API_TOKEN;
export const ChannelOverview_API_TOKEN = process.env.REACT_APP_CHANNEL_OVERVIEW_API_TOKEN;
export const Blog_API_TOKEN = process.env.REACT_APP_BLOG_API_TOKEN;
export const Media_Base_URL = process.env.REACT_APP_MEDIA_BASE_URL;
export const Support_API_TOKEN = process.env.REACT_APP_SUPPORT_API_TOKEN;
export const Home_API_TOKEN = process.env.REACT_APP_HOME_API_TOKEN;
export const LEGAL_COMPLIANCE_INFORMATION_API_TOKEN = process.env.REACT_APP_LEGAL_COMPLIANCE_INFORMATION_API_TOKEN;
export const CONTACT_INFO_API_TOKEN = process.env.REACT_APP_CONTACT_INFO_API_TOKEN;
export const SUBSCRIBER_ENQUIRY_API_TOKEN = process.env.REACT_APP_SUBSCRIBER_ENQUIRY_API_TOKEN;
export const ONLINE_SALES_TEAM_API_TOKEN = process.env.REACT_APP_ONLINE_SALES_TEAM_API_TOKEN;
export const BROADCAST_LOCATION_API_TOKEN = process.env.REACT_APP_BROADCAST_LOCATION_API_TOKEN;
export const ADVERTISER_API_TOKEN = process.env.REACT_APP_ADVERTISER_API_TOKEN;
export const BUSINESS_API_TOKEN = process.env.REACT_APP_BUSINESS_API_TOKEN;
export const Header_API_TOKEN = process.env.REACT_APP_HEADER_API_TOKEN;

// NowID Backend URLs
export const IDBE_URL = getEnvVar('IDBE_URL');
export const ACCOUNT_API_URL = getEnvVar('ACCOUNT_API_URL');
export const RB_ACCOUNT_API_URL = getEnvVar('RB_ACCOUNT_API_URL');
export const MYACCOUNT_URL = getEnvVar('MYACCOUNT_URL');
export const LOGIN_URL = getEnvVar('LOGIN_URL');
export const LOGIN_HANDLER_URL = process.env.REACT_APP_LOGIN_HANDLER_URL || '';
export const HOME_BOOTSTRAP_URL = process.env.REACT_APP_HOME_BOOTSTRAP_URL || '';
export const ID_URL = getEnvVar('ID_URL');
export const TV_BINDING_URL = getEnvVar('TV_BINDING_URL');
export const SHOP_HOST = getEnvVar('SHOP_HOST');

// Redirection URLs
export const SPRINGBOARD_URL = ENV === 'development' || ENV === 'staging' 
  ? "https://onlineuat.nowtv.now.com/nowtv-app/" 
  : "https://online.nowtv.now.com/nowtv-app/";
export const SSP_URL = ENV === 'development' || ENV === 'staging'
  ? "https://ssp.nowtv.now.com/"
  : "https://ssp.nowtv.now.com/"; // Looks like it's the same for now based on inc files

// Proxy endpoint for NowID API calls
export const NOWID_PROXY_URL = process.env.REACT_APP_NOWID_PROXY_URL || '/api/nowid-proxy.php';
export const REDEEM_CODE_PROXY_URL = process.env.REACT_APP_REDEEM_CODE_PROXY_URL || '/api/redeem-code-proxy.php';

// Log current environment configuration for debugging
// console.log('Current environment:', ENV);
// console.log('API URL:', API_URL);